export default "__VITE_ASSET__9d5bd89b__"